/**
 * DermaMedic Search Modal — quick-links visibility toggle.
 * Show discovery + Carola's picks when input is empty/focused;
 * hide as soon as the user starts typing (predictive results take over).
 */
(function () {
  function bindToggle(input) {
    const predictiveSearch = input.closest('predictive-search');
    if (!predictiveSearch) return;
    const quickLinks = predictiveSearch.querySelector('[data-search-quick-links]');
    if (!quickLinks) return;

    const showQuickLinks = () => {
      quickLinks.removeAttribute('hidden');
    };
    const hideQuickLinks = () => {
      quickLinks.setAttribute('hidden', '');
    };

    input.addEventListener('input', () => {
      if (input.value.trim().length > 0) hideQuickLinks();
      else showQuickLinks();
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length === 0) showQuickLinks();
    });
  }

  function init() {
    const inputs = document.querySelectorAll('.search-modal .search__input');
    inputs.forEach(bindToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
